module.exports = __webpack_public_path__ + "img/john-profile.7b3fa0c.jpg";